//rentlord\rl_frontend\src\components\Profile.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import Footer from './Footer';
import CircularProgress from '@mui/material/CircularProgress'; // Import CircularProgress for loading spinner
import { Container, Button, Grid2 } from '@mui/material';
import { Link } from 'react-router-dom';
import ModalDialog from './ModalDialog';
import Login from './Login';
import { useTranslation } from 'react-i18next';

const Profile = () => {
 const [user, setUser] = useState(null);
 const [profileData, setProfileData] = useState(null);
 const [error, setError] = useState('');
 const [loading, setLoading] = useState(true); // State for loading indicator
 const [openModal, setOpenModal] = useState(false);
 const { t } = useTranslation();


 useEffect(() => {
   // Retrieve user from localStorage on component mount and when user changes
   const userData = JSON.parse(localStorage.getItem('user'));
   if (!userData) {
      setOpenModal(true); // Open login modal if no user
    }
   setUser(userData);
 }, []);


 useEffect(() => {
   const fetchUserProfile = async () => {
     if (!user || !user.id || !user.token) {
       setError(t('profile.userOrTokenNotFound'));
       setLoading(false);
       return;
     }
     const config = {
       headers: {
         'Content-Type': 'application/json',
         'Authorization': `Token ${user.token}` 
       }
     };
     try {
       const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/profile/${user.id}`, config);
       setProfileData(response.data);
     } catch (error) {
       console.error('Error fetching profile:', error.response);
       setError(t('profile.errorFetching'));
     } finally {
       setLoading(false);
     }
   };


   if (user) {
     fetchUserProfile();
   }
 }, [user, t]);


 return (
    <div>
      <Navbar />
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', textAlign: 'center', marginBottom: '60px' }}>
        <Container>
            {error && <p>{error}</p>}
            {loading ? (
            <CircularProgress />
            ) : profileData ? (
              <div>
                <h2>{t('profile.title')}</h2>
                <h4>{t('profile.welcome', { username: profileData.username })}</h4>
                <p><strong>{t('profile.email')}</strong> {profileData.email}</p>
              </div>
            ) : (
              <p>{t('profile.noProfileData')}</p>
            )}
            <Grid2 item xs={12} sm={12} container justifyContent="center">
              <Button type="submit" variant="outlined" color="primary" sx={{ mt: 2 }} component={Link} to="/dashboard">
                {t('profile.dashboardButton')}
              </Button>
            </Grid2>
          </Container>
     </div>
      <div style={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 1000 }}>
        <Footer />
      </div>
      {/* Login Modal */}
      <ModalDialog open={openModal} onClose={() => setOpenModal(false)}>
        <Login onClose={() => setOpenModal(false)} />
      </ModalDialog>
    </div>
 );
};


export default Profile;
